
import React from "react";
import { Editor } from "@tiptap/react";
import { Code } from "lucide-react";
import MenuButton from "../MenuButton";

interface CodeToolProps {
  editor: Editor;
}

const CodeTool = ({ editor }: CodeToolProps) => {
  return (
    <MenuButton 
      onClick={() => editor.chain().focus().toggleCodeBlock().run()} 
      icon={<Code className="h-4 w-4" />} 
      tooltip="Code Block"
      isActive={editor.isActive('codeBlock')}
    />
  );
};

export default CodeTool;
